import { superAdminMenu } from './superAdminMenu';

export const managerMenu = [...superAdminMenu].filter(el => el.key !== 'sa-managers');

